export default "__VITE_ASSET__M8jb4jTa__"